<script lang="ts" setup>
import { SUREbusinessCommonDomainSoortVerzekeringEnum as SoortVerzekering } from '@services/polis-public/orval-api/model/sUREbusinessCommonDomainSoortVerzekeringEnum';
import { useQuery } from '@tanstack/vue-query';
import { toRefs } from 'vue';

import StringField from '@shared/form/StringField/StringField.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import FieldRowGroup from '@shared/form/FieldRowV2/FieldRowGroup.vue';
import { polisQueries } from '../polisQueries';

const props = defineProps<{
  polisnummer: string;
}>();

const { polisnummer } = toRefs(props);

const { data } = useQuery({
  ...polisQueries.getDetails(polisnummer),
  select: (res) => res.data,
  staleTime: 60000,
});
</script>
<template>
  <FieldRowGroup :gap="2">
    <FieldRowV2 label="Soort verzekering">
      <StringField readonly :value="data?.polis.omssoortverzekering" />
    </FieldRowV2>
    <FieldRowV2 label="Productomschrijving">
      <StringField readonly :value="data?.polis.omsproductcode" />
    </FieldRowV2>
    <FieldRowV2 label="Risicodrager" v-if="data?.polis.soortverzekering !== SoortVerzekering.Pp">
      <StringField readonly :value="data?.polis.maatschappijnaam" />
    </FieldRowV2>
    <FieldRowV2 label="Ingangsdatum">
      <StringField readonly :value="data?.datums.ingangsdatum" />
    </FieldRowV2>
    <FieldRowV2 label="Meest recente mutatie">
      <StringField
        readonly
        :value="`${data?.datums.mutatiedatum} / ${data?.polis.omsmutatiereden}`"
      />
    </FieldRowV2>
    <FieldRowV2 label="Contractvervaldatum">
      <StringField readonly :value="data?.datums.contractvervaldatum" />
    </FieldRowV2>
    <FieldRowV2 label="Expiratiedatum">
      <StringField readonly :value="data?.datums.expiratiedatum" />
    </FieldRowV2>
  </FieldRowGroup>
</template>
